import styled from 'styled-components'

import watchIcon from '../assets/progressbar-watch-icon.svg'
import loopIcon from '../assets/progressbar-loop-icon.svg'
import checkIcon from '../assets/progressbar-check-icon.svg'

const Icon = styled.div`
    width: 22px;
    height: 22px;
    margin-right: 12px;
`

const Watch= styled(Icon)`
    background: url(${watchIcon});
`

const Loop = styled(Icon)`
    background: url(${loopIcon});
`

const Check = styled(Icon)`
    background: url(${checkIcon});
`

const List = styled.ul`
    list-style: none;
    width: 100%;
    padding: 0 0 24px 0;
`

const Row = styled.li`
    display: flex;
    height: 36px;
    align-items: center;
`

type Props = {
    status: string,
}
const ProgressList = ({ status }: Props) => {
    return <List>
        <Row>
            {
                status === 'uploading' || status === 'waiting'
                ? <Loop /> 
                : <Check />
            }

            Uploading
        </Row>
        <Row>
            {
                status === 'uploading' || status === 'waiting'
                ? <Watch />
                : status === 'converting'
                ? <Loop />
                : <Check />
            }

            Converting
        </Row>

        <Row>
            {
                status !== 'redirecting'
                ? <Watch />
                : <Loop />
            }

            Redirecting
        </Row>
    </List>
}

ProgressList.displayName = "Progress List"

export default ProgressList